import React from "react";
import { makeStyles } from "@mui/styles";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { routes } from "../../routing/routes";
import { Link } from "react-router-dom";

const customStyles = makeStyles({
  root: {
    fontFamily: "Montserrat",
    backgroundColor: "black",
  },

  footer: {
    width: "90%",
    maxWidth: "1216px",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    paddingTop: "100px",
    paddingBottom: "50px",
    gap: "20px",
  },

  contactWrapper: {
    alignItems: "center",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },

  contactLeft: {
    display: "flex",
    flexDirection: "column",
    width: "60%",
    gap: "10px",
  },

  contactRight: {
    display: "flex",
    flexDirection: "column",
    width: "40%",
    gap: "14px",
  },

  contactRightItem: {
    gap: "15px",
    color: "white",
    display: "flex",
    flexWrap: "inherit",
    fontWeight: "600",
    alignItems: "center",
    marginLeft: "170px",
  },

  copyRights: {
    textAlign: "right",
    color: "#FFFFFF5C",
    fontSize: "16px",
    fontWeight: "500",
  },

  policyLinksContainer: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
    marginTop: "-20px",
  },

  policyLink: {
    color: "white",
    fontWeight: 500,
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "none",
      color: "#CCCCCC",
    },
  },

  // ----------- MEDIA QUERIES -----------
  "@media (max-width: 319px)": {
    contactLeft: { width: "100%", gap: "6px" },
    contactRight: { width: "100%", gap: "10px" },
    contactWrapper: { flexDirection: "column", gap: "20px" },
    copyRights: { fontSize: "14px", textAlign: "center" },
    policyLinksContainer: { justifyContent: "center" },
  },

  "@media (min-width: 320px) and (max-width: 480px)": {
    footer: { paddingTop: "60px", paddingBottom: "40px", gap: "60px" },
    contactWrapper: { flexDirection: "column" },
    contactLeft: { width: "100%", gap: "8px" },
    contactRight: { width: "100%", gap: "12px" },
    contactRightItem: { gap: "12px" },
    copyRights: { textAlign: "center", fontSize: "15px" },
    policyLinksContainer: { justifyContent: "center" },
  },

  "@media (min-width: 481px) and (max-width: 768px)": {
    footer: { paddingTop: "80px", paddingBottom: "40px", gap: "80px" },
    contactWrapper: { flexDirection: "row", justifyContent: "space-between" },
    contactLeft: { width: "50%", gap: "10px" },
    contactRight: { width: "50%", gap: "14px" },
    copyRights: { textAlign: "center", fontSize: "16px" },
  },

  "@media (min-width: 769px) and (max-width: 1024px)": {
    footer: { paddingTop: "90px", paddingBottom: "50px", gap: "90px" },
    contactWrapper: { flexDirection: "row", justifyContent: "space-between" },
    contactLeft: { width: "50%", gap: "12px" },
    contactRight: { width: "50%", gap: "16px" },
    copyRights: { textAlign: "center", fontSize: "17px" },
  },

  "@media (min-width: 1025px) and (max-width: 1440px)": {
    contactLeft: { width: "60%" },
    contactRight: { width: "40%" },
  },

  "@media (min-width: 1441px)": {
    footer: { maxWidth: "1400px" },
    contactLeft: { width: "65%" },
    contactRight: { width: "35%" },
  },
});

const RootFooter = () => {
  const classes = customStyles();
  return (
    <div className={classes.root}>
      <div className={classes.footer}>
        <div className={classes.contactWrapper}>
          <div className={classes.contactLeft}>
            <span className="white-text font-size-36 font-weight-600">
              Contact information
            </span>
            <span className="grey-text">Call us anytime – +91 73974 60454</span>
          </div>
          <div className={classes.contactRight}>
            <div className={classes.contactRightItem}>
              <EmailOutlinedIcon fontSize="small" color="primary" /> contact@alpaago.com
            </div>
            <div className={classes.contactRightItem}>
              <PhoneIcon fontSize="small" color="primary" /> +91 73974 60454
            </div>
            <div className={classes.contactRightItem}>
              <LocationOnIcon fontSize="small" color="primary" /> No 155, 2nd Main, 7th Cross, Kengeri, Bangalore 560060
            </div>
          </div>
        </div>

        {/* ✅ Updated legal company name for Razorpay compliance */}
        <div className={classes.copyRights}>
          © 2024 ALPAAGO INDIA PRIVATE LIMITED. All Rights Reserved.
        </div>

        <div className={classes.policyLinksContainer}>
          <Link to={routes.REFUND_POLICY} className={classes.policyLink}>Refund Policy</Link>
          <Link to={routes.RETURN_POLICY} className={classes.policyLink}>Return Policy</Link>
          <Link to={routes.PRIVACY_POLICY} className={classes.policyLink}>Privacy Policy</Link>
          <Link to={routes.TERMS_CONDITIONS} className={classes.policyLink}>Terms & Conditions</Link>
          <Link to={routes.DELIVERY_POLICY} className={classes.policyLink}>Delivery Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default RootFooter;
